import styled from 'styled-components'
import { Text, Icon, TextButton, ToggleButton as StormToggleButton, Button as StormButton } from '@amzn/storm-ui'
import { customColor, customBgColor, customFont, customPadding, customMargin } from '../style'
import { MediaContainer as CommonMediaContainer } from '../../../common/components/MediaContainer'

export const largeScreen = '@media (min-width: 1280px)'
export const smallScreen = '@media (max-width: 1279.999px)'

type ContainerType = {
  variant: 'ccxEmptyGrey' | 'white'
}

export const Headline = styled(Text)`
  margin: 30px;
`

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 550px;
  max-height: calc(100vh - 4rem);
`

// Overriding the storm ui modal style because whats new modal requires special styling
export const ModalStyle = styled.div`
  & + div > div > div > div {
    overflow-y: unset;
    max-width: 1000px;
    max-height: calc(100vh - 4rem);
  }

  & + div > div {
    min-width: 588px;
    width: 1000px;
  }
`

export const Container = styled.div<ContainerType>`
  display: flex;
  flex: auto;
  overflow-y: auto;
  background-color: ${({ variant, theme }) => theme.palette[variant]};
`

export const MenuContainer = styled.div`
  max-width: 270px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  ${customPadding('none', 'medium', 'base', 'medium')}
  background: ${({ theme }) => theme.palette.ccxEmptyGrey};
  box-sizing: border-box;
  overflow-y: auto;

  ${smallScreen} {
    max-width: 196px;
  }
`

export const ProductAnnouncementContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.xlarge};
  margin-top: auto;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 30px ${({ theme }) => theme.spacing.xxlarge} ${({ theme }) => theme.spacing.large};
  overflow-y: auto;
`

export const ContentBodyContainer = styled.div`
  display: flex;

  ${smallScreen} {
    flex-direction: column-reverse;
    padding-top: ${({ theme }) => theme.spacing.medium};
  }
`

export const CloseButton = styled(TextButton)`
  border: none;
  background-color: transparent;
  ${customPadding()}
  margin-top: -30px;
  margin-right: 30px;
`

export const CloseIcon = styled(Icon)`
  font-size: 20px;
  ${customPadding('none', 'micro', 'none', 'micro')}
  ${customColor('white')}
  &:hover {
    cursor: pointer;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  ${customBgColor('inkwell')}
  ${customColor('white')}
  text-align: left;
`

export const ToggleButton = styled(StormToggleButton)<{ active: boolean }>`
  margin: 0 -${({ theme }) => theme.spacing.medium};
  ${customPadding('base', 'medium', 'base', 'medium')}
  font-size: 15px;
  line-height: 19px;
  ${customColor()}
  text-align: left;
  border: unset;
  background: ${({ active, theme }) => (active ? theme.palette.white : `unset`)};
  font-weight: normal;
  border-radius: 0;
  &:hover {
    background: ${({ theme }) => theme.palette.ccxToggleWhite};
  }
`
export const DateText = styled(Text)`
  line-height: 18px;
  color: ${({ theme }) => theme.palette.ccxTextGreyOne};
  ${customMargin('small', 'none', 'small', 'none')}
`

export const TextContainer = styled.div`
  min-width: 320px;
  flex: 1;
  align-items: baseline;
  padding-right: ${({ theme }) => theme.spacing.xlarge};

  ${smallScreen} {
    padding-right: 0px;
  }
`

export const HeaderText = styled(Text)`
  font-size: 21px;
  line-height: 25px;
  ${customColor()}
  text-align: left;
`

const BaseBodyText = styled(Text)`
  ${customFont()}
  line-height: 19px;
  color: ${({ theme }) => theme.palette.ccxTextGreyTwo};
`

export const BodyText = styled(BaseBodyText)`
  && {
    ${customMargin('medium', 'none', 'large', 'none')}

    ${smallScreen} {
      ${customMargin('none', 'none', 'large', 'none')}
    }
  }
`

export const MultilineBodyText = styled(BaseBodyText)`
  &&:not(:last-of-type) {
    ${customMargin('none', 'none', 'mini', 'none')}

    ${smallScreen} {
      ${customMargin('none', 'none', 'mini', 'none')}
    }
  }
`

export const Button = styled(StormButton)`
  ${customMargin('base', 'none', 'none', 'none')}
  display: block;
`
export const DotIcon = styled(Icon)`
  color: rgb(1, 132, 133);
  padding-right: 6px;
  font-size: 8px;
  vertical-align: bottom;
`

export const MediaContainer = styled(CommonMediaContainer)`
  ${largeScreen} {
    margin-top: ${({ theme }) => theme.spacing.medium};
  }
`
